/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo, useState } from 'react'
import { useDispatch } from 'react-redux';

import { setWallCloseStateWrap } from '../../../../../../../action';
import { const_var, params } from '../../../../../../../redux/reducers/reducer';

import { CSG } from '../../../../../../../assets/libs/csg-lib';
import { delModel, extrudeSettings, jTrimModel, wainscotTrimModel } from '../../../../../../../utils/Functions';
import { MaterialTrim, MaterialWainScotTrimNew } from '../../../../../CustomMaterial';

const TrimModel = () => {
    const dispatch = useDispatch();

    const [frontWallCloseSize, setFrontWallCloseSize] = useState(0);
    const [backWallCloseSize, setBackWallCloseSize] = useState(0);
    const [rightWallCloseSize, setRightWallCloseSize] = useState(0);
    const [leftWallCloseSize, setLeftWallCloseSize] = useState(0);

    const wallThickness = 0.005;
    const Temp_F_p_w = params.leanF_p_w - 0.3;

    const frontJTrimState = params.p_j_t_end && params.p_b_c_b_f_f !== "Open" && params.p_b_c_b_f_f !== "Close";
    const backJTrimState = params.p_j_t_end && params.p_b_c_b_f_b !== "Open" && params.p_b_c_b_f_b !== "Close";
    const rightJTrimState = params.p_j_t && params.p_b_c_b_f_r !== "Open" && params.p_b_c_b_f_r !== "Close" && params.p_b_c_b_f_r !== "Half Dutch End" && params.p_b_c_b_f_r !== "Half End";
    const leftJTrimState = params.p_j_t && params.p_b_c_b_f_l !== "Open" && params.p_b_c_b_f_l !== "Close" && params.p_b_c_b_f_l !== "Half Dutch End" && params.p_b_c_b_f_l !== "Half End";
    
    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined])

    const offset = useMemo(() => {
        if (params.frontLeanStoragePosition === params.leanF_p_d - parseInt(params.add_storage_front)) {
            return 0;
        } else if (params.frontLeanStoragePosition === 0) {
            return 0.8;
        } else {
            return 0.5;
        }
    }, [params.leanF_p_d, legDistance, params.frontLeanStoragePosition, params.add_storage_front]);

    // const dutchDelModelFront = useMemo(() => {
    //     const freeSpace = 1;
    //     const trimWidth = 0.2;
    //     const offset = 0.05 * Math.pow(2, 1 / 2)
    //     let cornerFreeSpaceW = (params.leanF_p_d - freeSpace) / 6;
    //     let cornerFreeSpaceH = (params.leanF_p_h - freeSpace) / 6
    //     if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

    //     if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
    //     if (params.add_front_lean && (params.p_b_c_b_f_f === "Half Dutch End" || params.p_b_c_b_f_f === "Half End")) {
    //         const model = new THREE.Shape();
    //         model.moveTo(-(params.leanF_p_d / 2 - freeSpace), 0);

    //         if (params.p_b_c_b_f_f === "Half Dutch End") {
    //             model.lineTo(-(params.leanF_p_d / 2 - freeSpace), params.leanF_p_h - freeSpace - cornerFreeSpaceH);
    //             model.lineTo(-(params.leanF_p_d / 2 - freeSpace - cornerFreeSpaceW), params.leanF_p_h - freeSpace);
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace - cornerFreeSpaceW), params.leanF_p_h - freeSpace);
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace), params.leanF_p_h - freeSpace - cornerFreeSpaceH);
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace), 0);
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace - trimWidth), 0);
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace - trimWidth), params.leanF_p_h - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace - cornerFreeSpaceW - offset), params.leanF_p_h - freeSpace - trimWidth);
    //             model.lineTo(-(params.leanF_p_d / 2 - freeSpace - cornerFreeSpaceW - offset), params.leanF_p_h - freeSpace - trimWidth);
    //             model.lineTo(-(params.leanF_p_d / 2 - freeSpace - trimWidth), params.leanF_p_h - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
    //         } else {
    //             model.lineTo(-(params.leanF_p_d / 2 - freeSpace), params.leanF_p_h - freeSpace);
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace), params.leanF_p_h - freeSpace);
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace), 0);
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace - trimWidth), 0);
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace - trimWidth), params.leanF_p_h - freeSpace - trimWidth);
    //             model.lineTo(-(params.leanF_p_d / 2 - freeSpace - trimWidth), params.leanF_p_h - freeSpace - trimWidth);
    //         }
    //         model.lineTo(-(params.leanF_p_d / 2 - freeSpace - trimWidth), 0);
    //         model.closePath()

    //         return model;
    //     } else {
    //         return []
    //     }
    // }, [params.add_front_lean, params.leanF_p_d, params.leanF_p_h, params.p_b_c_b_f_f])

    // const dutchDelModelBack = useMemo(() => {
    //     const freeSpace = 1;
    //     const trimWidth = 0.2;
    //     const offset = 0.05 * Math.pow(2, 1 / 2)
    //     let cornerFreeSpaceW = (params.leanF_p_d - freeSpace) / 6;
    //     let cornerFreeSpaceH = (params.leanF_p_h - freeSpace) / 6
    //     if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

    //     if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
    //     if (params.add_front_lean && (params.p_b_c_b_f_b === "Half Dutch End" || params.p_b_c_b_f_b === "Half End")) {
    //         const model = new THREE.Shape();
    //         model.moveTo(-(params.leanF_p_d / 2 - freeSpace), 0);

    //         if (params.p_b_c_b_f_b === "Half Dutch End") {
    //             model.lineTo(-(params.leanF_p_d / 2 - freeSpace), params.leanF_p_h - freeSpace - cornerFreeSpaceH);
    //             model.lineTo(-(params.leanF_p_d / 2 - freeSpace - cornerFreeSpaceW), params.leanF_p_h - freeSpace);
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace - cornerFreeSpaceW), params.leanF_p_h - freeSpace);
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace), params.leanF_p_h - freeSpace - cornerFreeSpaceH);
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace), 0);
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace - trimWidth), 0);
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace - trimWidth), params.leanF_p_h - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace - cornerFreeSpaceW - offset), params.leanF_p_h - freeSpace - trimWidth);
    //             model.lineTo(-(params.leanF_p_d / 2 - freeSpace - cornerFreeSpaceW - offset), params.leanF_p_h - freeSpace - trimWidth);
    //             model.lineTo(-(params.leanF_p_d / 2 - freeSpace - trimWidth), params.leanF_p_h - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
    //         } else {
    //             model.lineTo(-(params.leanF_p_d / 2 - freeSpace), params.leanF_p_h - freeSpace);
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace), params.leanF_p_h - freeSpace);
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace), 0);
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace - trimWidth), 0);
    //             model.lineTo((params.leanF_p_d / 2 - freeSpace - trimWidth), params.leanF_p_h - freeSpace - trimWidth);
    //             model.lineTo(-(params.leanF_p_d / 2 - freeSpace - trimWidth), params.leanF_p_h - freeSpace - trimWidth);
    //         }
    //         model.lineTo(-(params.leanF_p_d / 2 - freeSpace - trimWidth), 0);
    //         model.closePath()

    //         return model;
    //     } else {
    //         return []
    //     }
    // }, [params.add_front_lean, params.leanF_p_d, params.leanF_p_h, params.p_b_c_b_f_b])
    
    const frontLeftVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_f_f === "Open" || params.p_b_c_b_f_f === "Gable")) {
            model.moveTo(Temp_F_p_w / 2 + 0, frontWallCloseSize);
            model.lineTo(Temp_F_p_w / 2 + 0, params.leanF_p_h - (params.b_l_t_r_pF / 12 * 0.1));
            model.lineTo(Temp_F_p_w / 2 + 0.23, params.leanF_p_h - (params.b_l_t_r_pF / 12 * 0.1));
            model.lineTo(Temp_F_p_w / 2 + 0.23, frontWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.leanF_p_h, Temp_F_p_w, frontWallCloseSize, params.p_b_c_b_f_f, params.b_l_t_r_pF])
    
    const frontRightVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_f_f === "Open" || params.p_b_c_b_f_f === "Gable")) {
            model.moveTo(-(Temp_F_p_w / 2 + 0.235), frontWallCloseSize);
            model.lineTo(-(Temp_F_p_w / 2 + 0.235), params.leanF_p_h - (params.b_l_t_r_pF / 12 * 0.1));
            model.lineTo(-(Temp_F_p_w / 2 + 0), params.leanF_p_h - (params.b_l_t_r_pF / 12 * 0.1));
            model.lineTo(-(Temp_F_p_w / 2 + 0), frontWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.leanF_p_h, Temp_F_p_w, frontWallCloseSize, params.p_b_c_b_f_f, params.b_l_t_r_pF])
    
    const rightWallLeftVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_f_r === "Open" || params.p_b_c_b_f_r === "Gable")) {
            model.moveTo(-(Temp_F_p_w / 2 ), params.leanF_p_h);
            model.lineTo(-(Temp_F_p_w / 2 ), rightWallCloseSize);
            model.lineTo(-(Temp_F_p_w / 2 + 0.235), rightWallCloseSize);
            model.lineTo(-(Temp_F_p_w / 2 + 0.235), params.leanF_p_h);
            model.closePath();
        }

        return model;
    }, [rightWallCloseSize, params.p_b_c_b_f_r, params.leanF_p_h, Temp_F_p_w, params.leanF_p_d, params.p_b_c_b_f_f])
    
    const leftWallRightVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_f_l === "Open" || params.p_b_c_b_f_l === "Gable")) {
            model.moveTo((Temp_F_p_w / 2 ), params.leanF_p_h);
            model.lineTo((Temp_F_p_w / 2 ), leftWallCloseSize);
            model.lineTo((Temp_F_p_w / 2 + 0.235), leftWallCloseSize);
            model.lineTo((Temp_F_p_w / 2 + 0.235), params.leanF_p_h);
            model.closePath();
        }

        return model;
    }, [leftWallCloseSize, params.p_b_c_b_f_l, params.leanF_p_h, Temp_F_p_w, params.leanF_p_d, params.p_b_c_b_f_f])

    const backLeftVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_f_b === "Open" || params.p_b_c_b_f_b === "Gable")) {
            model.moveTo(-(Temp_F_p_w / 2 + 0.235), backWallCloseSize);
            model.lineTo(-(Temp_F_p_w / 2 + 0.235), params.leanF_p_h - (params.b_l_t_r_pF / 12 * 0.1));
            model.lineTo(-(Temp_F_p_w / 2 + 0), params.leanF_p_h - (params.b_l_t_r_pF / 12 * 0.1));
            model.lineTo(-(Temp_F_p_w / 2 + 0), backWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.leanF_p_h, Temp_F_p_w, backWallCloseSize, params.p_b_c_b_f_b, params.b_l_t_r_pF])

    const backRightVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_f_b === "Open" || params.p_b_c_b_f_b === "Gable")) {
            model.moveTo(Temp_F_p_w / 2 + 0, backWallCloseSize);
            model.lineTo(Temp_F_p_w / 2 + 0, params.leanF_p_h - (params.b_l_t_r_pF / 12 * 0.1));
            model.lineTo(Temp_F_p_w / 2 + 0.23, params.leanF_p_h - (params.b_l_t_r_pF / 12 * 0.1));
            model.lineTo(Temp_F_p_w / 2 + 0.23, backWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.leanF_p_h, Temp_F_p_w, backWallCloseSize, params.p_b_c_b_f_b, params.b_l_t_r_pF])

    const frontWallHrTrimObj = useMemo(() => {
        let main;
        let wainscot;
        
        // j trim
        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(Temp_F_p_w + 0.2)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableFrontLeanFront', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
            
        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.position.set(-(Temp_F_p_w / 2 + 0.15), frontWallCloseSize + 0.1, 0.05)
        meshJTrimModel_Temp.rotation.y = Math.PI/2
        meshJTrimModel_Temp.updateMatrixWorld()
    
        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(params.leanF_p_pos, 0, 0.5);
        meshDelModel_Temp.rotation.y = Math.PI;
        meshDelModel_Temp.updateMatrixWorld()
        
        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        
        const JTrimModel_CSG_Temp = meshJTrimModel_CSG.subtract(meshDelModel_CSG);
        const CSGJTrimModel = CSG.toMesh(JTrimModel_CSG_Temp,new THREE.Matrix4())

        main = CSGJTrimModel.geometry

        // wainscot trim
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(Temp_F_p_w + 0.02)), new THREE.MeshStandardMaterial({color: 'red'}))

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.position.set(-(Temp_F_p_w / 2 + 0.02), 3, 0.06)
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/2
        meshWainscotTrimModel_Temp.updateMatrixWorld()

        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);

        const WainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);
        const CSGWainscotTrimModel = CSG.toMesh(WainscotTrimModel_CSG, new THREE.Matrix4())

        wainscot = CSGWainscotTrimModel.geometry

        return {main, wainscot}
    }, [Temp_F_p_w, frontWallCloseSize, params.leanF_p_pos, params.add_left_front_lean_porch, params.add_left_back_lean_porch, params.p_b_c_b_f_l, params.add_storage_check_front, params.add_storage_front, params.leanF_p_h, const_var.newDoorsArray])

    const backWallHrTrimObj = useMemo(() => {
        let main;
        let wainscot;
        
        // j trim
        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(Temp_F_p_w + 0.2)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableFrontLeanBack', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
            
        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.position.set((Temp_F_p_w / 2 + 0.15), backWallCloseSize + 0.1, params.leanF_p_d - 0.16);
        meshJTrimModel_Temp.rotation.y = -Math.PI/2;
        meshJTrimModel_Temp.updateMatrixWorld();
    
        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(params.leanF_p_pos, 0, -0.5 + params.leanF_p_d);
        meshDelModel_Temp.updateMatrixWorld()
        
        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        
        const JTrimModel_CSG_Temp = meshJTrimModel_CSG.subtract(meshDelModel_CSG);
        const CSGJTrimModel = CSG.toMesh(JTrimModel_CSG_Temp,new THREE.Matrix4())

        main = CSGJTrimModel.geometry

        // wainscot trim
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(Temp_F_p_w + 0.3)), new THREE.MeshStandardMaterial({color: 'red'}))

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.position.set((Temp_F_p_w / 2 + 0.15), 3, params.leanF_p_d - 0.16);
        meshWainscotTrimModel_Temp.rotation.y = -Math.PI/2;
        meshWainscotTrimModel_Temp.updateMatrixWorld();

        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);

        const WainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);
        const CSGWainscotTrimModel = CSG.toMesh(WainscotTrimModel_CSG,new THREE.Matrix4())

        wainscot = CSGWainscotTrimModel.geometry

        return {main, wainscot}
    }, [Temp_F_p_w, backWallCloseSize, params.leanF_p_pos, params.leanF_p_d, params.p_b_c_b_f_l, params.add_storage_check_front, params.add_storage_front, params.leanF_p_h, const_var.newDoorsArray])
    
    const rightWallHrTrimObj = useMemo(() => {
        let main;
        let wainscot;

        const storageDelModelSizeOffset = params.frontLeanStoragePosition === params.leanF_p_d - parseInt(params.add_storage_front) ? 0.3 : 0

        const storageRightWallModel = new THREE.Shape();
        storageRightWallModel.moveTo((params.p_d / 2 + 0.15), params.leanF_p_h);                          
        storageRightWallModel.lineTo((params.p_d / 2 + storageDelModelSizeOffset + parseInt(params.add_storage_front) + offset), params.leanF_p_h);        
        storageRightWallModel.lineTo((params.p_d / 2 + storageDelModelSizeOffset + parseInt(params.add_storage_front) + offset), 0);  
        storageRightWallModel.lineTo((params.p_d / 2 + 0.15), 0);                    
        storageRightWallModel.closePath();

        // j trim
        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.leanF_p_d - 0.1)), new THREE.MeshStandardMaterial({color: 'red'}))
        const storageRightWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageRightWallModel, extrudeSettings(1)));
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableFrontLeanRight', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
    
        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.position.set(-(Temp_F_p_w / 2 + 0.1525), rightWallCloseSize + 0.1, params.leanF_p_d - 0.1)
        meshJTrimModel_Temp.rotation.y = Math.PI
        meshJTrimModel_Temp.updateMatrixWorld()

        let storageRightWallDelModel_Temp = storageRightWallDelModel.clone();
        storageRightWallDelModel_Temp.rotateY(Math.PI / 2);
        storageRightWallDelModel_Temp.position.set(-Temp_F_p_w / 2 - 0.5, 0, params.p_d / 2 + params.leanF_p_d - params.frontLeanStoragePosition + 0.36);
        storageRightWallDelModel_Temp.updateMatrixWorld();

        let meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set( -params.leanF_p_w / 2 + 0.5, 0, params.leanF_p_d + params.p_d / 2);
        meshDelModel_Temp.rotation.y = -Math.PI / 2;
        meshDelModel_Temp.updateMatrixWorld();
        
        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const storageRightWallDelModel_CSG = CSG.fromMesh(storageRightWallDelModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);

        let storageJTrimDelModel;
        if(params.add_storage_check_front){
            storageJTrimDelModel = meshJTrimModel_CSG.subtract(storageRightWallDelModel_CSG);
        } else {
            storageJTrimDelModel = meshJTrimModel_CSG;
        }
        const JTrimDelModel_CSG = storageJTrimDelModel.subtract(meshDelModel_CSG);
        const CSGJTrimModel = CSG.toMesh(JTrimDelModel_CSG, new THREE.Matrix4())
        main = CSGJTrimModel.geometry
        
        // wainscot trim
        const meshWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanF_p_d - 0.1)))
        let meshWainscotModel_Temp = meshWainscotModel.clone();
        meshWainscotModel_Temp.position.set(-(Temp_F_p_w / 2 + 0.155), 3, (params.leanF_p_d) - 0.1)
        meshWainscotModel_Temp.rotation.y = Math.PI
        meshWainscotModel_Temp.updateMatrixWorld();
    
        const meshWainscotModel_CSG = CSG.fromMesh(meshWainscotModel_Temp);

        let storageWainscotTrimDelModel;
        if(params.add_storage_check_front){
            storageWainscotTrimDelModel = meshWainscotModel_CSG.subtract(storageRightWallDelModel_CSG);
        } else {
            storageWainscotTrimDelModel = meshWainscotModel_CSG;
        }

        const wainscotModel_CSG = storageWainscotTrimDelModel.subtract(meshDelModel_CSG);

        const CSGWainscotModel = CSG.toMesh(wainscotModel_CSG, new THREE.Matrix4())
        wainscot = CSGWainscotModel.geometry

        return {main, wainscot}
    }, [params.leanF_p_d, Temp_F_p_w, params.p_w, rightWallCloseSize, const_var.newDoorsArray, offset, params.frontLeanStoragePosition, params.add_storage_check_front, params.add_storage_front])

    const leftWallHrTrimObj = useMemo(() => {
        let main;
        let wainscot;

        const storageDelModelSizeOffset = params.frontLeanStoragePosition === params.leanF_p_d - parseInt(params.add_storage_front) ? 0.3 : 0

        const storageLeftWallModel = new THREE.Shape();
        storageLeftWallModel.moveTo(-(params.p_d / 2 + 0.15), params.leanF_p_h);                         
        storageLeftWallModel.lineTo(-(params.p_d / 2 + storageDelModelSizeOffset + parseInt(params.add_storage_front) + offset), params.leanF_p_h);      
        storageLeftWallModel.lineTo(-(params.p_d / 2 + storageDelModelSizeOffset + parseInt(params.add_storage_front) + offset), 0); 
        storageLeftWallModel.lineTo(-(params.p_d / 2 + 0.15), 0);                    
        storageLeftWallModel.closePath();

        // j trim
        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.leanF_p_d - 0.1)), new THREE.MeshStandardMaterial({color: 'red'}))
        const storageLeftWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageLeftWallModel, extrudeSettings(1)))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableFrontLeanLeft', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))

        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.position.set((Temp_F_p_w / 2 + 0.1525), leftWallCloseSize + 0.1, 0)
        meshJTrimModel_Temp.updateMatrixWorld();

        let storageLeftWallDelModel_Temp = storageLeftWallDelModel.clone();
        storageLeftWallDelModel_Temp.rotateY(Math.PI / -2);
        storageLeftWallDelModel_Temp.position.set((Temp_F_p_w / 2) + 0.5, 0, params.p_d / 2 + params.leanF_p_d - params.frontLeanStoragePosition + 0.36);
        storageLeftWallDelModel_Temp.updateMatrixWorld();
        
        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.rotateY(Math.PI / -2);
        meshDelModel_Temp.position.set((Temp_F_p_w / 2) + 0.5, 0, (params.leanF_p_d) + params.p_d / 2 + 0.05);
        meshDelModel_Temp.updateMatrixWorld();
        
        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const storageLeftWallDelModel_CSG = CSG.fromMesh(storageLeftWallDelModel_Temp);
    
        let storageJTrimDelModel;
        if(params.add_storage_check_front){
            storageJTrimDelModel = meshJTrimModel_CSG.subtract(storageLeftWallDelModel_CSG);
        } else{
            storageJTrimDelModel = meshJTrimModel_CSG;
        }
        const JTrimModel_CSG = storageJTrimDelModel.subtract(meshDelModel_CSG);
        const CSGJTrimModel = CSG.toMesh(JTrimModel_CSG,new THREE.Matrix4());
        main = CSGJTrimModel.geometry;

        // wainscot trim
        const meshWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanF_p_d - 0.1)))
        let meshWainscotModel_Temp = meshWainscotModel.clone();
        meshWainscotModel_Temp.position.set((Temp_F_p_w / 2 + 0.155), 3, 0)
        meshWainscotModel_Temp.updateMatrixWorld();
    
        const meshWainscotModel_CSG = CSG.fromMesh(meshWainscotModel_Temp);

        let storageWainscotTrimDelModel;
        if(params.add_storage_check_front){
            storageWainscotTrimDelModel = meshWainscotModel_CSG.subtract(storageLeftWallDelModel_CSG);
        } else{
            storageWainscotTrimDelModel = meshWainscotModel_CSG;
        }
    
        const wainscotModel_CSG = storageWainscotTrimDelModel.subtract(meshDelModel_CSG);
        const CSGWainscotModel = CSG.toMesh(wainscotModel_CSG,new THREE.Matrix4());
        wainscot = CSGWainscotModel.geometry;

        return {main, wainscot}
    }, [params.leanF_p_d, Temp_F_p_w, params.p_w, const_var.newDoorsArray, leftWallCloseSize, offset, params.frontLeanStoragePosition, params.add_storage_check_front, params.add_storage_front])

    // --- left wall close state    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_f_l === 'Open' || typeof(params.p_b_c_b_f_l) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanF_p_h - 0.25;
            } else {
                tempWallCloseSize = params.leanF_p_h;
            }
        } else if (params.p_b_c_b_f_l === "One_Fourth_Close") {
            tempWallCloseSize = params.leanF_p_h / 4 * 3;
        } else if (params.p_b_c_b_f_l === "Half_Close") {
            tempWallCloseSize = params.leanF_p_h / 2;
        } else if (params.p_b_c_b_f_l === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanF_p_h / 4;
        } else if (params.p_b_c_b_f_l === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanF_p_h - 3 * params.p_b_c_b_f_l;
        }

        setLeftWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'FLfrontWallCloseState': tempWallCloseSize}))
    }, [params.p_b_c_b_f_l, params.leanF_p_h, params.p_r_s])

    // --- right wall set    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_f_r === 'Open' || typeof(params.p_b_c_b_f_r) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanF_p_h - 0.25;
            } else {
                tempWallCloseSize = params.leanF_p_h;
            }
        } else if (params.p_b_c_b_f_r === "One_Fourth_Close") {
            tempWallCloseSize = params.leanF_p_h / 4 * 3;
        } else if (params.p_b_c_b_f_r === "Half_Close") {
            tempWallCloseSize = params.leanF_p_h / 2;
        } else if (params.p_b_c_b_f_r === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanF_p_h / 4;
        } else if (params.p_b_c_b_f_r === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanF_p_h - 3 * params.p_b_c_b_f_r;
        }

        setRightWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'FLRightWallCloseState': tempWallCloseSize}))
    }, [params.p_b_c_b_f_r, params.leanF_p_h, params.p_r_s])
    
    // --- front wall set    
    useMemo(() => {
        let tempWallCloseSize;
        if (params.p_b_c_b_f_f === "One_Fourth_Close") {
            tempWallCloseSize = params.leanF_p_h / 4 * 3;
        } else if (params.p_b_c_b_f_f === "Gable") {
            tempWallCloseSize = params.leanF_p_h - 0.2;
        } else if (params.p_b_c_b_f_f === "Half_Close") {
            tempWallCloseSize = params.leanF_p_h / 2;
        } else if (params.p_b_c_b_f_f === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanF_p_h / 4;
        } else if (params.p_b_c_b_f_f === "Close") {
            tempWallCloseSize = 0;
        } else if (params.p_b_c_b_f_f === "Half Dutch End") {
            tempWallCloseSize = 0;
        } else if (params.p_b_c_b_f_f === "Half End") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = -1;
        }

        setFrontWallCloseSize(tempWallCloseSize);
    }, [params.p_b_c_b_f_f, params.leanF_p_h, params.p_r_s])

    // --- back wall set    
    useMemo(() => {
        let tempWallCloseSize;
        if (params.add_storage_check_front) {
            tempWallCloseSize = 0;
        } else {
            if (params.p_b_c_b_f_b === "One_Fourth_Close") {
                tempWallCloseSize = params.leanF_p_h / 4 * 3;
            } else if (params.p_b_c_b_f_b === "Gable") {
                tempWallCloseSize = params.leanF_p_h - 0.2;
            } else if (params.p_b_c_b_f_b === "Half_Close") {
                tempWallCloseSize = params.leanF_p_h / 2;
            } else if (params.p_b_c_b_f_b === "Three_Fourth_Close") {
                tempWallCloseSize = params.leanF_p_h / 4;
            } else if (params.p_b_c_b_f_b === "Half End") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_f_b === "Half Dutch End") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_f_b === "Close") {
                tempWallCloseSize = 0;
            } else {
                tempWallCloseSize = -1;
            }
        }

        setBackWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'FLRightWallCloseState': tempWallCloseSize}))
    }, [params.add_storage_check_front, params.p_b_c_b_f_b, params.leanF_p_h, params.p_r_s])

    return (
        <>
            <group position={[0, 0, (params.p_d / 2 + params.leanF_p_d + 0.05 + wallThickness)]} rotation={[0, Math.PI, 0]}>
                <mesh name="right-wall-left-trim" position={[0, 0, -0.015]}>
                    <extrudeGeometry args={[rightWallLeftVrTrimModel, extrudeSettings(0.16)]} />
                    <MaterialTrim visibleSection={"gableFrontLean"} />
                </mesh>
                <mesh name="left-wall-right-trim" position={[0, 0, -0.015]}>
                    <extrudeGeometry args={[leftWallRightVrTrimModel, extrudeSettings(0.16)]} />
                    <MaterialTrim visibleSection={"gableFrontLean"} />
                </mesh>
                <mesh name="front-wall-left-trim" position={[0, 0, -0.015]}>
                    <extrudeGeometry args={[frontLeftVrTrimModel, extrudeSettings(0.16)]} />
                    <MaterialTrim visibleSection={"gableFrontLean"} />
                </mesh>
                <mesh name="front-wall-right-trim"position={[0, 0, -0.015]}>
                    <extrudeGeometry args={[frontRightVrTrimModel, extrudeSettings(0.16)]} />
                    <MaterialTrim visibleSection={"gableFrontLean"} />
                </mesh>

                <group position={[0, 0, params.leanF_p_d - 0.23]}>
                    {/* {params.leanF_p_pos !== (params.p_w - params.leanF_p_w) / 2 && <> */}
                        <mesh name="right-wall-right-trim" position={[0, 0, -0.015]}>
                            <extrudeGeometry args={[rightWallLeftVrTrimModel, extrudeSettings(0.16)]} />
                            <MaterialTrim visibleSection={"gableFrontLean"} />
                        </mesh>
                        <mesh name="back-wall-left-trim" position={[0, 0, -0.015]}>
                            <extrudeGeometry args={[backLeftVrTrimModel, extrudeSettings(0.16)]} />
                            <MaterialTrim visibleSection={"gableFrontLean"} />
                        </mesh>
                    {/* </>} */}
                    {/* {params.leanF_p_pos !== -(params.p_w - params.leanF_p_w) / 2 && <> */}
                        <mesh name="left-wall-left-trim" position={[0, 0, -0.015]}>
                            <extrudeGeometry args={[leftWallRightVrTrimModel, extrudeSettings(0.16)]} />
                            <MaterialTrim visibleSection={"gableFrontLean"} />
                        </mesh>
                        <mesh name="back-wall-right-trim"position={[0, 0, -0.015]}>
                            <extrudeGeometry args={[backRightVrTrimModel, extrudeSettings(0.16)]} />
                            <MaterialTrim visibleSection={"gableFrontLean"} />
                        </mesh>
                    {/* </>} */}
                </group>

                {frontJTrimState &&
                    <mesh name="front-wall-J-trim" geometry={frontWallHrTrimObj.main}>
                        <MaterialTrim visibleSection={"gableFrontLean"} />
                    </mesh>
                }
                {backJTrimState &&
                    <mesh name="back-wall-J-trim" geometry={backWallHrTrimObj.main}>
                        <MaterialTrim visibleSection={"gableFrontLean"} />
                    </mesh>
                }
                {rightJTrimState &&
                    <mesh name="right-wall-J-trim" geometry={rightWallHrTrimObj.main}>
                        <MaterialTrim visibleSection={"gableFrontLean"} />
                    </mesh>
                }
                {leftJTrimState &&
                    <mesh name="side-wall-J-trim" geometry={leftWallHrTrimObj.main}>
                        <MaterialTrim visibleSection={"gableFrontLean"} />
                    </mesh>
                }

                {params.p_w_c_n === true && params.p_b_c_b_f_f === "Close" &&
                    <mesh name="G_F_L_F_W_wainscotTrim" geometry={frontWallHrTrimObj.wainscot} >
                        <MaterialWainScotTrimNew visibleSection={"gableFrontLean"}  />
                    </mesh>
                }
                {params.p_w_c_n === true && params.p_b_c_b_f_b === "Close" &&  
                    <mesh name="G_F_L_B_W_wainscotTrim" geometry={backWallHrTrimObj.wainscot} >
                        <MaterialWainScotTrimNew visibleSection={"gableFrontLean"}  />
                    </mesh>
                }
                {params.p_w_c_n === true && params.p_b_c_b_f_r === "Close" &&
                    <mesh name="G_F_L_R_W_wainscotTrim" geometry={rightWallHrTrimObj.wainscot} >
                        <MaterialWainScotTrimNew visibleSection={"gableFrontLean"}  />
                    </mesh>
                }
                {params.p_w_c_n === true && params.p_b_c_b_f_l === "Close" &&
                    <mesh name="G_F_L_L_W_wainscotTrim" geometry={leftWallHrTrimObj.wainscot} >
                        <MaterialWainScotTrimNew visibleSection={"gableFrontLean"}  />
                    </mesh>
                }
            </group>

            {/* <mesh position={[ -(params.leanF_p_d / 2 + params.p_w / 2), 0, Temp_F_p_w / 2 + 0.1]} >
                <extrudeGeometry args={[dutchDelModelFront, extrudeSettings(0.15)]}/>
                <MaterialTrim visibleSection={"gableFrontLean"} />
            </mesh>
            <mesh position={[ -(params.leanF_p_d / 2 + params.p_w / 2), 0, - (Temp_F_p_w / 2 + 0.25)]} >
                <extrudeGeometry args={[dutchDelModelBack, extrudeSettings(0.15)]}/>
                <MaterialTrim visibleSection={"gableFrontLean"} />
            </mesh> */}
        </>
    )
}

export default TrimModel
